
import React from 'react';
import { motion } from 'framer-motion';
// Added ArrowRight to imports
import { Headphones, Music, Stars, PartyPopper, ArrowRight } from 'lucide-react';

const services = [
  {
    title: "Mariages d'Exception",
    description: "Une installation élégante et un habillage lumineux sur mesure pour sublimer le plus beau jour de votre vie.",
    icon: <Stars className="w-8 h-8" />,
    image: "/images/djsaff-event-mariage.jpg"
  },
  {
    title: "Évènements Privés",
    description: "Anniversaires, soirées privées, fêtes d'entreprise. Une programmation adaptée à vos envies les plus folles.",
    icon: <PartyPopper className="w-8 h-8" />,
    image: "/images/dj-saff-event.jpg"
  },
  {
    title: "Clubbing & Festivals",
    description: "Une énergie explosive généraliste, avec une spécialisation Afro-Vibes, Amapiano et Afrohouse pour enflammer les dancefloors.",
    icon: <Headphones className="w-8 h-8" />,
    image: "/images/djsaff-event-club-havana.jpg"
  }
];

const ServiceCard: React.FC<{ service: typeof services[0], index: number }> = ({ service, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.2, duration: 0.8 }}
      className="group relative h-[500px] overflow-hidden rounded-3xl cursor-pointer"
    >
      <div className="absolute inset-0 bg-dark-lighter">
        <img 
          src={service.image} 
          alt={service.title} 
          className="w-full h-full object-cover opacity-40 grayscale group-hover:scale-110 group-hover:grayscale-0 transition-all duration-1000"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/20 to-transparent" />
      
      <div className="absolute inset-0 p-10 flex flex-col justify-end">
        <div className="w-16 h-16 glass rounded-2xl flex items-center justify-center text-gold mb-6 group-hover:scale-110 transition-transform duration-500">
          {service.icon}
        </div>
        <h3 className="text-3xl font-serif font-bold mb-4">{service.title}</h3>
        <p className="text-white/60 line-clamp-2 mb-6 group-hover:text-white transition-colors">
          {service.description}
        </p>
        {/*<div className="flex items-center space-x-2 text-gold text-xs font-bold uppercase tracking-widest opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-500">*/}
        {/*  */}{/*<span>En savoir plus</span>*/}
        {/*  */}{/*<ArrowRight size={14} />*/}
        {/*</div>*/}
      </div>
    </motion.div>
  );
};

const Services: React.FC = () => {
  return (
    <section id="services" className="py-24 bg-dark-lighter/30">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <motion.span 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="text-gold text-xs font-bold tracking-[0.4em] uppercase"
          >
            Prestations
          </motion.span>
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-6xl font-serif font-bold mt-4"
          >
            L'Excellence du <span className="text-gold-gradient italic">Mix</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, idx) => (
            <ServiceCard key={idx} service={service} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;